import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, mediaUrl, apiErr } from "@/lib/api";
import { Field, Input, Button } from "@/lib/ui";

export default function PaymentQR() {
  const ref = useRef();
  const [qr, setQr] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/admin/settings/payment-qr").then(({ data }) => { setQr(data.qr_url); setNote(data.note); }); }, []);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setQr(data.url); toast.success("QR uploaded — remember to Save");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  const save = async () => {
    try { await api.post("/admin/settings/payment-qr", { qr_url: qr, note }); toast.success("Payment QR saved — sellers will now see it"); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div>
      <h1 className="font-head text-2xl font-extrabold text-slate-900">Payment QR</h1>
      <p className="mt-1 text-sm text-slate-500">Upload the UPI / bank QR code sellers use to pay. It appears on their subscription & slot payment screens.</p>

      <div className="mt-5 grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <p className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-500">Current QR</p>
          <div onClick={() => ref.current.click()} data-testid="qr-upload"
            className="flex aspect-square cursor-pointer items-center justify-center overflow-hidden rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 hover:border-orange-400">
            {busy ? <span className="text-slate-400"><i className="fa-solid fa-spinner fa-spin" /> Uploading…</span> :
              qr ? <img src={mediaUrl(qr)} alt="Payment QR" className="h-full w-full object-contain p-2" /> :
                <span className="text-center text-sm text-slate-400"><i className="fa-solid fa-qrcode mb-2 block text-3xl" />Click to upload QR</span>}
          </div>
          <input ref={ref} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files[0])} />
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <Field label="QR Image URL" hint="Auto-filled after upload, or paste an external URL"><Input value={qr} onChange={(e) => setQr(e.target.value)} data-testid="qr-url" /></Field>
          <div className="mt-3"><Field label="Payment Note / UPI ID"><Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. UPI: deadstock@okhdfc" data-testid="qr-note" /></Field></div>
          <Button className="mt-4 w-full" onClick={save} data-testid="qr-save">Save Payment QR</Button>
        </div>
      </div>
    </div>
  );
}
